"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = exports.Item = exports.Breadcrumb = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Breadcrumb = _styledComponents["default"].nav.withConfig({
  displayName: "Breadcrumbstyle__Breadcrumb",
  componentId: "sc-1m0a1gz-0"
})({
  display: 'inline-block',
  ol: {
    listStyle: 'none',
    padding: 0,
    margin: 0
  },
  li: {
    display: 'inline-block',
    ':first-child svg': {
      display: 'none'
    }
  }
});

exports.Breadcrumb = Breadcrumb;

var Item = _styledComponents["default"].span.withConfig({
  displayName: "Breadcrumbstyle__Item",
  componentId: "sc-1m0a1gz-1"
})(function (_ref) {
  var theme = _ref.theme,
      onClick = _ref.onClick,
      href = _ref.href;
  return _extends({
    background: 'transparent',
    border: 0,
    textTransform: 'uppercase',
    color: onClick || href ? theme.color.brandPrimary.light : theme.color.neutral['03'],
    textDecoration: onClick || href ? 'underline' : 'none',
    cursor: onClick || href ? 'pointer' : 'default',
    padding: "".concat(theme.spacing.inline['6xs'], " ").concat(theme.spacing.inline['5xs'], "}")
  }, (0, _utils.getTextStyle)({
    theme: theme,
    variant: 'caption-01',
    margin: false
  }), {
    ':hover': {
      color: onClick || href ? theme.color.brandPrimary.medium : theme.color.neutral['03'],
      textDecoration: 'none'
    }
  });
});

exports.Item = Item;

var Arrow = _styledComponents["default"].svg.withConfig({
  displayName: "Breadcrumbstyle__Arrow",
  componentId: "sc-1m0a1gz-2"
})(function (_ref2) {
  var color = _ref2.theme.color;
  return {
    color: color.brandPrimary.light,
    margin: 0,
    width: '1em',
    height: '1em',
    top: '.125em',
    position: 'relative'
  };
});

exports.Arrow = Arrow;